import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {User, UserRole} from "../../../../models/user";
import {NgForm} from "@angular/forms";

@Component({
    selector: 'epds-add-or-edit-gao-user',
    templateUrl: './add-or-edit-gao-user.component.html',
    styleUrl: './add-or-edit-gao-user.component.scss',
    standalone: false
})
export class AddOrEditGaoUserComponent implements OnInit {
  @Input() user: User|null|undefined;
  @Output() btnClicked = new EventEmitter<any>();
  @Input() addOrEditInd: 'A'|'E'|null = 'E';
  @Input() saving = false;
  confirmGaoId: string = '';
  groupNumbers = [0, 1, 2, 3, 4, 5, 6, 7];
  gaoRoles = [
    {
      'name': 'ADMIN',
      'value': UserRole.GAO_Admin
    },
    {
      'name': 'ATTORNEY',
      'value': UserRole.GAO_Attorney
    },
    {
      'name': 'SUPERVISOR',
      'value': UserRole.GAO_Supervisor
    }
  ];

  selectedUser: User|null|undefined;

  constructor() {
  }

  ngOnInit() {
    if (this.user) {
      this.selectedUser = {...this.user};
    }
  }

  onSubmit() {
    if (this.selectedUser?.gao_user_id === this.confirmGaoId) {
      console.log(this.selectedUser);
    } else {
      console.log('GAO IDs do not match');
    }
  }

  disablePaste($event: ClipboardEvent) {
    $event.preventDefault();
  }

  canSave(registerForm: NgForm) {
    let canBeSaved = registerForm.valid && registerForm.dirty;

    if (this.addOrEditInd === 'A') {
      canBeSaved = canBeSaved && (this.selectedUser?.gao_user_id === this.confirmGaoId);
    }

    return canBeSaved;
  }

  populateRole() {
    if(this.selectedUser?.role_id) {
      this.selectedUser.role = this.gaoRoles.
                       find(each =>
                            each.value === this.selectedUser?.role_id
                        )?.name || '';
    }
  }
}


